export const data = [
  { id: 0, name: 'MTS', src: '/images/mts.png' },
  { id: 1, name: 'MEGAFON', src: '/images/megafon.jpg' },
  { id: 2, name: 'BEELINE', src: '/images/beeline.png' },
]
